import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { VivaSliderComponent } from './viva-slider.component';

@NgModule({
  declarations: [
    VivaSliderComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    VivaSliderComponent
  ]
})
export class  VivaSliderModule { }
